"use client"

import { NpAccessoriesCarousel } from "src/components/np-design/sections/cart-sidebar/NpAccessoriesCarousel"
import { ResolvedAccessoryProductData } from "src/data/product-accessories-resolved/types"

export type NpCartSidebarAccessoriesProps = {
  accessories: ResolvedAccessoryProductData[]
}

export const NpCartSidebarAccessories = ({ accessories }: NpCartSidebarAccessoriesProps) => {
  if (!accessories.length) {
    return null
  }

  return (
    <div className="flex flex-col gap-6 py-6">
      <h3 className="text-h3-np m-0 px-6">Bestell gleich das passende Zubehör mit</h3>

      <NpAccessoriesCarousel accessories={accessories} />
    </div>
  )
}
